import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/resettime.png'
import _imports_1 from '@/assets/anquanxunjian/steptip.png'


const _withScopeId = n => (_pushScopeId("data-v-0245cda2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "filterarea" }
const _hoisted_2 = { class: "selecttime" }
const _hoisted_3 = { class: "contentlist" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "steptip",
  src: _imports_1
}, null, -1))
const _hoisted_5 = { class: "step-top" }
const _hoisted_6 = { class: "record-code" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "content-area" }
const _hoisted_9 = { class: "imgbox" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "show-loaction" }
const _hoisted_12 = { style: {"color":"#c13737"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_dropdown_item = _resolveComponent("van-dropdown-item")!
  const _component_van_dropdown_menu = _resolveComponent("van-dropdown-menu")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_van_step = _resolveComponent("van-step")!
  const _component_van_steps = _resolveComponent("van-steps")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!
  const _component_van_calendar = _resolveComponent("van-calendar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_van_nav_bar, {
      "left-arrow": "",
      title: _ctx.$route.meta.title,
      placeholder: "",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_van_dropdown_menu, null, {
        default: _withCtx(() => [
          _createVNode(_component_van_dropdown_item, {
            modelValue: _ctx.selectType,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectType) = $event)),
            options: _ctx.allQuestions,
            onChange: _ctx.fChangeSearch
          }, null, 8, ["modelValue", "options", "onChange"]),
          _createVNode(_component_van_dropdown_item, {
            modelValue: _ctx.selectStatus,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectStatus) = $event)),
            options: _ctx.allStatus,
            onChange: _ctx.fChangeSearch
          }, null, 8, ["modelValue", "options", "onChange"])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (this.calendarShow = true))
        }, _toDisplayString(_ctx.date ? _ctx.currentDate() : "请选择时间"), 1),
        _createElementVNode("img", {
          src: _imports_0,
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.fSetTime && _ctx.fSetTime(...args)))
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: "addbtn",
        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.fGoAdd && _ctx.fGoAdd(...args)))
      }, [
        _createVNode(_component_van_icon, { name: "plus" })
      ]),
      _createVNode(_component_van_pull_refresh, {
        modelValue: _ctx.refreshing,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.refreshing) = $event)),
        onRefresh: _ctx.onRefresh
      }, {
        default: _withCtx(() => [
          _createVNode(_component_van_list, {
            loading: _ctx.loading,
            "onUpdate:loading": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.loading) = $event)),
            finished: _ctx.finished,
            "finished-text": "没有更多了",
            "loading-text": "正在加载,请稍后..",
            onLoad: _ctx.onLoad
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_steps, {
                direction: "vertical",
                "active-color": "#0A3F70",
                "inactive-color": "#0A3F70",
                active: 10
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.safeList, (item) => {
                    return (_openBlock(), _createBlock(_component_van_step, {
                      key: item.id
                    }, {
                      "inactive-icon": _withCtx(() => [
                        _hoisted_4
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("div", null, [
                            _createElementVNode("div", null, "创建时间：" + _toDisplayString(item.createDate), 1),
                            _createElementVNode("div", _hoisted_6, "记录编号：" + _toDisplayString(item.photoNo), 1)
                          ]),
                          _createElementVNode("div", {
                            class: _normalizeClass(["step-status", {
                  _no: item.status === 1,
                  _yes: item.status === 2,
                  _resove: item.status === 3,
                  _lou: item.status === 4,
                }])
                          }, _toDisplayString(item.status === 1
                    ? "未处理"
                    : item.status === 2
                    ? "已处理"
                    : "已解决"), 3)
                        ]),
                        _createElementVNode("div", {
                          class: "step-content",
                          onClick: ($event: any) => (_ctx.fGoDetail(item))
                        }, [
                          _createElementVNode("div", _hoisted_8, _toDisplayString(item.title), 1),
                          _createElementVNode("div", _hoisted_9, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.imgFileList, (img, idx) => {
                              return (_openBlock(), _createElementBlock("div", { key: idx }, [
                                _createElementVNode("img", {
                                  class: "stepimg",
                                  src: img.url
                                }, null, 8, _hoisted_10)
                              ]))
                            }), 128))
                          ]),
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, " 限定整改：" + _toDisplayString(item.limitDate != null ? item.limitDate.substr(0, 10) : "无"), 1),
                            _createElementVNode("div", null, [
                              _createVNode(_component_svg_icon, { "icon-class": "dingwei" }),
                              _createTextVNode(" " + _toDisplayString(item.areaName), 1)
                            ])
                          ])
                        ], 8, _hoisted_7)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["loading", "finished", "onLoad"])
        ]),
        _: 1
      }, 8, ["modelValue", "onRefresh"])
    ]),
    _createVNode(_component_van_calendar, {
      "min-date": new Date('2019-01-01'),
      show: _ctx.calendarShow,
      "onUpdate:show": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.calendarShow) = $event)),
      onConfirm: _ctx.fConfirmDate
    }, null, 8, ["min-date", "show", "onConfirm"])
  ], 64))
}